<script lang="ts" setup>
import { PropType, ref, defineExpose, watch } from 'vue';
import { SubtaskModel } from '@/components/task-forms/models';
import { TaskSubtaskView } from '@/components/task-forms/components';

/**Параметры */
const props = defineProps({
  /**id преокта */
  projectId: { type: Number, required: true },
  /**Список подзадач */
  subtasks: { type: Array as PropType<SubtaskModel[]> },
  /**id очереди */
  queueId: { type: String },
  editing: { type: Boolean, default: true },
});
/**События */
const emit = defineEmits<{
  /**Удаление подзадачи */
  remove: [taskId: number];
  /**Событие обновления подзадачи */
  updatedSubtask: [subtaskId: number];
}>();

/**Ссылка на подзадачи */
const $subtaskList = ref<InstanceType<typeof TaskSubtaskView>>();

defineExpose({
  subtask: $subtaskList,
});
</script>
<template>
  <div class="subtasks-list">
    <TaskSubtaskView
      ref="$subtaskList"
      v-for="subtask in subtasks"
      :projectId="projectId"
      :subtask="subtask"
      :key="subtask.Id"
      :queueId="queueId"
      :editing="editing"
      @on-click-delete="emit('remove', subtask.Id)"
      @updatedSubtask="emit('updatedSubtask', $event)"
    />
  </div>
</template>
<style lang="scss" scoped>
.subtasks-list {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}
</style>
